// extracted by mini-css-extract-plugin
module.exports = {"button":"c6e8ba5398--button--1Lnua","simplified-button":"c6e8ba5398--simplified-button--3wjoc"};